// src/components/companion/SofiaFab.jsx — Sofia's floating entry point.
// The fleet pattern: the AI companion lives as a bubble at bottom-right,
// not a nav item. Hidden on /companion itself (she's already open there).
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const SofiaFab = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/companion')) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.4 }}
      className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-4 sm:bottom-6 sm:right-6 z-50"
    >
      <Link
        to="/companion"
        aria-label="Talk to Sofia, your philosophy companion"
        className="group flex items-center gap-2 pl-4 pr-1.5 py-1.5 rounded-full bg-slate-900/95 border border-bright-gold/50 shadow-lg shadow-black/40 hover:border-bright-gold transition-all"
      >
        {/* Permanent label: hover-only labels never show on touch */}
        <span className="text-sm font-semibold text-bright-gold whitespace-nowrap">Ask Sofia</span>
        <span className="block w-10 h-10 sm:w-11 sm:h-11 rounded-full overflow-hidden border-2 border-bright-gold/60 shadow-lg shadow-black/40 group-hover:border-bright-gold group-hover:scale-105 transition-all bg-gunmetal">
          <img
            src="/images/characters/sofia.webp"
            alt=""
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
              e.target.parentElement.insertAdjacentHTML('beforeend', '<span class="text-bright-gold font-bold text-xl">S</span>');
            }}
          />
        </span>
      </Link>
    </motion.div>
  );
};

export default SofiaFab;
